// URL helpers: clean SEO paths and short `sort` params.

export const ORDERING_MAP = {
  'listing__price': 'pret',
  '-listing__price': '-pret',
  '-listing__created_at': 'noi',
  'listing__created_at': '-noi',
  '-listing__modified_at': 'modificat',
  'listing__modified_at': '-modificat',
};

export const ORDERING_REVERSE = Object.fromEntries(
  Object.entries(ORDERING_MAP).map(([k, v]) => [v, k])
);

// Short URL value -> full API value (legacy full values pass through).
export const toShortOrdering = (v) => ORDERING_MAP[v] ?? v;
export const toFullOrdering = (v) => ORDERING_REVERSE[v] ?? v;

export const DEFAULT_SORT = 'noi';

export const NUMERIC_RE = /^\d+$/;
// Listing slugs always end with "-<id>".
export const SLUG_ID_RE = /-\d+$/;
// Rooms landing pages: 1-camera, 2-camere, 3-camere, 4-camere...
export const ROOMS_RE = /^[1-9]-camer[ae]$/;

// e.g. buildListPath('terenuri', { location: 'ungheni', sector: '', saleType: 2 })
//   -> '/terenuri/ungheni/chirie'
export const buildListPath = (base, { location = '', sector = '', saleType = 1 }) =>
  `/${base}${location ? `/${location}` : ''}${sector ? `/${sector}` : ''}${Number(saleType) === 2 ? '/chirie' : ''}`;


// Normalize phone numbers for display: always with +373 prefix.
export const formatPhone = (value) => {
    const digits = String(value || '').replace(/[^\d]/g, '');
    if (!digits) return value || '';
    if (digits.startsWith('373') && digits.length === 11) return `+${digits}`;
    if (digits.startsWith('0') && digits.length === 9) return `+373${digits.slice(1)}`;
    if (digits.startsWith('0') && digits.length === 8) return `+373${digits.slice(1)}`;
    if (digits.length === 8) return `+373${digits}`;
    return `+${digits}`;
};
